import { EvaluatorContext } from "../../../../../evaluator/Evaluator"
import EvaluateRequest from "../../../../../EvaluateRequest"
import EvaluationEventRecorder from "../../../../../event/EvaluationEventRecorder"
import RemoteEvaluator from "../../../../../mode/remote/RemoteEvaluator"
import { InAppMessageLayoutEvaluateResponse } from "../../InAppMessageLayoutEvaluateResponse"
import { InAppMessageLayoutRemoteEvaluateRequest } from "./InAppMessageLayoutRemoteEvaluateRequest"
import InAppMessageLayoutEvaluator from "../../InAppMessageLayoutEvaluator"

/**
 * Resolves an in-app message layout in remote evaluation. The server has already selected the
 * message, so the layout result carried by the request is returned unchanged; the base evaluator
 * resolves the result's references into the context first.
 */
export class InAppMessageLayoutRemoteEvaluator
  extends RemoteEvaluator<InAppMessageLayoutRemoteEvaluateRequest, InAppMessageLayoutEvaluateResponse>
  implements InAppMessageLayoutEvaluator<InAppMessageLayoutRemoteEvaluateRequest>
{
  constructor(private readonly eventRecorder: EvaluationEventRecorder) {
    super()
  }

  /**
   * @override
   */
  supports(request: EvaluateRequest): request is InAppMessageLayoutRemoteEvaluateRequest {
    return request instanceof InAppMessageLayoutRemoteEvaluateRequest
  }

  /**
   * @override
   */
  protected remoteEvaluate(
    request: InAppMessageLayoutRemoteEvaluateRequest,
    context: EvaluatorContext
  ): InAppMessageLayoutEvaluateResponse {
    return InAppMessageLayoutEvaluateResponse.of(request, context, request.inAppMessage)
  }

  /**
   * @override
   */
  record(_request: InAppMessageLayoutRemoteEvaluateRequest, response: InAppMessageLayoutEvaluateResponse): void {
    this.eventRecorder.record(response)
  }
}
